<template>
  <div>
    <div class="card">
      <div class="card-header border-0">
        <div class="row ml-0">

          <table-tool-menu
            class="col-12"
            :title="title"
            :addTitle="addTitle"
            :editTitle="editTitle"
            :isAdd="isAdmin"
            :isEdit="isAdmin"
            :isDelete="false"
            :isCopy="false"
            :isSingleSelect="selectRow"
            :isMultiSelect="false"
            :processing="false"
            :disableMoveDown="false"
            :disableMoveUp="false"
            @addNew="onClickNewProject"
            @edit="onEditProject(selectedData)"
          >
          </table-tool-menu>
        </div>
      </div>

      <el-table
        ref="projectTable"
        cell-class-name="pt-1 pb-1"
        class="table-responsive align-items-center table-flush"
        header-row-class-name="thead-light"
        header-cell-class-name="table-header-normal mr-2"
        select-on-indeterminate="true"
        @select="handleSelectRow"
        @select-all="handleSelectAllRow"
        @sort-change="runSort"
        :empty-text="emptyText"
        :data="pagedData"
      >
        <el-table-column v-if="isAdmin" type="selection" align="left" min-width="120px">
        </el-table-column>
        <el-table-column
          label="プロジェクト名"
          min-width="410px"
          prop="project.name"
          sortable="'custom'"
        >
          <template v-slot="{ row }">
            <div>
            <a href="#!" class="font-size-middle block font-weight-bold" @click.prevent="onClickProject(row)"
              >{{ row.project.name }}
            </a>
            </div>
            <div>
            <span v-if="row.project.description">{{ row.project.description }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="updatedAt" min-width="140px" sortable="'custom'" class-name="text-right">
          <template #header>
            <div style="width:100%;text-align:right;">{{$t('共通.3')}}</div>
          </template>
          <template v-slot="{ row }">
            <span>{{ dateStringFormat(row.updatedAt) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="$t('共通.4')" width="160px" prop="updatedUser" sortable="'custom'">
          <template v-slot="{ row }">
            <span>{{ userStringFormat(row.updatedUser) }}</span>
          </template>
        </el-table-column> -->
        
      </el-table>
      <div class="mt-1 d-flex justify-content-center">
      <el-pagination
        @current-change="setCurrent"
        :page-size="pagination.perPage"
        :current-page="pagination.currentPage"
        layout="prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
    </div>
    
  </div>
</template>
<script>

import {
  ElTable,
  ElTableColumn,
  ElDropdownMenu,
  ElDropdownItem,
  ElDropdown,
} from "element-plus";
import UserModel from "../../appModel/users/UserModel";
import ProjectModel from "../../appModel/project/ProjectModel";
import TableToolMenu from "../components/Menu/TableToolMenu"
import DateUtil from '../../appUtils/DateUtil';
import SortUtil from '../../appUtils/SortUtil';


export default {
  name: "inline-actions-table",
  props: {
    p_login_user_sub: {
      type: String,
      default: "",
    },
    p_login_tenant: {
      type: String,
      default: "",
    },
    p_login_usertype: {
      type: String,
      default: "",
    }
  },
  components: {
    [ElTable.name]: ElTable,
    [ElTableColumn.name]: ElTableColumn,
    [ElDropdown.name]: ElDropdown,
    [ElDropdownItem.name]: ElDropdownItem,
    [ElDropdownMenu.name]: ElDropdownMenu,
    TableToolMenu,
  },
  data() {
    return {
      //users,
      userList: [],
      projects: [],
      currentPage: 1,
      selectedData: null,
      title: "プロジェクト一覧",
      addTitle: "新規プロジェクトの作成",
      editTitle: "プロジェクトの編集",
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      isAdmin: false,
      loadComplete: false
    };
  },
  /**
   * コンピュートプロパティ
   */
  computed: {
    selectRow() {
      if (this.selectedData) {
        return true;
      } else {
        return false;
      }
    },
    /***
     * ページング用のデータをかえす
     */
    pagedData() {
      return this.projects.slice(this.from, this.to)
    },
    /**
     * ページング制御用
     */
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    /**
     * ページング制御用
     */
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    /**
     * ページング制御用
     */
    total() {
      return this.projects.length;
    },
    emptyText() {
      if (!this.loadComplete) {
        return "読み込み中"
      } else {
        return "プロジェクトはありません"
      }
    }
  },
  mounted() {
   
  },
  async created() {
    // テナント有効期限、ユーザーのログインチェック
    if (!await this.$root.validateSession()) {
      return
    }
    let loader = this.showLoader();
    
    // プロジェクトの選択内容をクリアする
    try {
      let store = this.$store.state.project;
      store = null;
      this.$store.commit("setProject", store);
      // 編集モードをリセットする
      let projectEdit = this.$store.state.projectEdit
      projectEdit.mode = null;
      this.$store.commit("setProjectEdit", projectEdit);
      console.log(`mounted ${JSON.stringify(projectEdit)}`)
    } catch (e) {
      console.log(JSON.stringify(e))
    }

    try {
      let navInfo = this.$store.state.navInfo
      navInfo.title = "プロジェクト一覧"
      navInfo.description = ""
      this.$store.commit("setNavInfo", navInfo)
      await this.getProjectList();

    } catch (e) {
      console.log(JSON.stringify(e))
    } finally {
      this.hideLoader(loader);
    }
  },
  methods: {
    setCurrent(newPage) {
      this.pagination.currentPage = newPage
    },
    async getProjectList() {
      // ログインユーザー情報取得
      this.loadComplete = false
      console.log(`p_login_user_sub ${this.p_login_user_sub}`)
      console.log(`p_login_user_sub ${this.p_login_tenant}`)
      const userInfo = await this.$root.getUserInfo()

      // ユーザー名称表示用にユーザー一覧取得
      this.userList = await UserModel.getUserList(userInfo.group);
      // プロジェクト一覧取得(一旦ワークに格納)
      let workProject = await ProjectModel.getProjectList(userInfo.group);

      // ログインユーザーの権限チェック
      let userAuthority = this.userList.filter(function (item){
        if (item.user.userId == userInfo.sub)
          return true;
      })
      // ユーザーの権限が一般の場合は、プロジェクトのメンバーにログインしたユーザーIDがなければ表示対象外
      let targteProject = [];
      let judge = false;
      if (userAuthority[0].user.usertype == "0") {
      // if (this.p_login_usertype == "0") {
        // ユーザー権限が一般の場合
        for (let i=0; i<workProject.length; i++)
        {
          judge = false;
          for (let j=0; j<workProject[i].project.members.length; j++)
          {
            // ログインユーザーIDがプロジェクトのメンバーにいるかチェック
            if (workProject[i].project.members[j].userId == userInfo.sub)
            {
              judge = true;
              break;
            }
          }

          // プロジェクトのメンバーにいた場合は、一覧に表示する
          if (judge == true)
          {
            targteProject.push(workProject[i]);
          }
        }
        // 判定した結果のプロジェクト一覧をセット
        this.projects = targteProject;
      } else {
        // 権限が管理者の場合は取得したプロジェクト一覧をそのまま表示
        this.projects = workProject;
        this.isAdmin = true
      }
      this.loadComplete = true
      // console.log(`projects:${JSON.stringify(this.projects,null,"\t")}`)
    },
    onClickNewProject() {
      // プロジェクト選択状態をクリア
      let project = this.$store.state.project
      project = {};
      this.$store.commit("setProject", project);

      let projectEdit = this.$store.state.projectEdit
      // 新規モードをセット
      projectEdit.mode = 1;
      this.$store.commit("setProjectEdit", projectEdit);
      
      this.$router.push({
        name: "NewProject",
      });
    },
    onClickProject(row) {
      // let id = row.sk.split("#")[1];
      // 選択したプロジェクトをセット
      let store = this.$store.state.project;
      store = {
        project: {
          id: row.project.id
        }
      };
      this.$store.commit("setProject", store);
      
      let notice = this.$store.state.notice
      notice.linkedId = ""
      notice.treePlace = ""
      this.$store.commit("setNotice", notice)
      
      // 編集画面に遷移
      this.$router.push({
        path: `/projectMain`
      });
    },

    onEditProject(row) {
      console.log(JSON.stringify(row, null, "\t"));
      let store = this.$store.state.project;
      store = row;
      this.$store.commit("setProject", store);

      let projectEdit = this.$store.state.projectEdit
      // 編集モードをセット
      projectEdit.mode = 2;
      this.$store.commit("setProjectEdit", projectEdit);

      this.$router.push({
        name: "EditProject",
        params: {
          p_login_user_sub: this.p_login_user_sub,
          p_login_tenant: this.p_login_tenant,
          p_login_usertype: this.p_login_usertype,
        }
      });
    },
    handleSelectRow(selection, row) {
      
      // 今回選択した行以外は選択を外し、常に単一選択とする
      for (let i = 0; i < selection.length; i++) {
        if (selection[i] != row) {
          this.$refs.projectTable.toggleRowSelection(selection[i], false)
        }
      }
      if (this.selectedData == row) {
        // 同一業の場合はチェックOFF
        this.selectedData = null;
      } else {
        this.selectedData = row;
      }

    },
    handleSelectAllRow() {
      // 全行選択時は選択を解除する
      this.$refs.projectTable.clearSelection();
      this.selectedData = null;
    },
    handleCurrentChange(currentRow, oldCurrentRow) {
      console.log(`handleCurrentChange`);

      // 同じ行を選択した場合は選択解除
      if (currentRow == oldCurrentRow) {
        this.$refs.projectTable.setCurrentRow();
        return;
      }
      this.selectedData = currentRow;
    },
    /**
     * 日付文字を別の形式に変更
     */
    dateStringFormat(dateString) {
      return DateUtil.getFormatString(dateString, "YYYY/MM/DD")
    },
    /**
     * ユーザーIDからユーザー名に変更
     */
    userStringFormat(userid) {
      // ユーザーIDでフィルター
      let userInfo = this.userList.filter(function (item){
        if (item.user.userId == userid)
          return true;
      })
      // ユーザー名称を取得し返却
      let retValue = "";
      if (userInfo.length > 0)
      {
        retValue = userInfo[0].user.name;
      }
      return retValue;
    },    
    /**
     * ソートを実行します。
     */
    async runSort(column) {
      await this.changeTableSort(column);
    },

    /**
     * テーブルのソート順を変更します。
     */
    async changeTableSort(column){
      console.log(column);

      if (column === false) {
        return;
      }

      // フィールド名とソート種別を取得
      let fieldName = column.prop;
      let sortingType = column.order;

      console.log(fieldName);

      if (!fieldName) {
        return;
      }

      // 復元用に保持
      // this.sortColumn = column;

      // 日本語ソート
      let isKana = true;
      if (fieldName == "createdAt") {
        isKana = false;
      }

      this.projects = await SortUtil.sort(this.projects, fieldName, sortingType, isKana);
    },
    /**
     * 処理中インジケーターを表示します。
     * @returns 表示したインジケーター
     */
    showLoader() {
      return this.$loading.show({
        container: null,
        canCancel: false,
        color: "#E4007F",
        width: 64,
        height: 64,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        isFullPage: true,
        zIndex: 9999,
      })
    },
    /**
     * 処理中インジケーターを閉じます。
     * @paramas {Object} loader 表示したインジケーター
     */
    hideLoader(loader) {
      loader.hide();
    },
  },
};
</script>
